import React, { useEffect, useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import { DownloadsContentModel } from "./DownloadsContentModel";
import ProductDownloads from "../ProductDownloads/ProductDownloads";

import "./DownloadsContent.css";
import Utils from "../../core/Utils/Utils";
import { themeService } from "../../core/NotificationStripNav/ThemeService";
import { Theme } from "../../core/Models/CustomSiteConfigModel";

const DownloadsContent: React.FC<{ blok: DownloadsContentModel }> = ({
  blok,
}) => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const product = params.get("product");
    setSearchTerm(product || "");

    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    Utils.setNavidation([{ param: "product", value }]);
    setSearchTerm(value);
  };

  return (
    <div
      {...storyblokEditable(blok)}
      className={`downloads-content-comp ${blok.display}`}
      style={{ backgroundColor: theme?.panelColour, color: theme?.textColor }}
    >
      <div className="input-container">
        <label className="input-label">
          AUDIOMOVERS SOFTWARE | LATEST VERSIONS
        </label>
        <input
          type="text"
          className="input-field"
          value={searchTerm}
          onChange={handleInputChange}
        ></input>
      </div>

      {blok.productDownloads
        ? blok.productDownloads.map((content) => (
            <ProductDownloads
              blok={content}
              searchTerm={searchTerm}
              key={content._uid}
            />
          ))
        : null}
    </div>
  );
};

export default DownloadsContent;
